import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CbPaginationModel } from './cb-pagination-model';

@Component({
  selector: 'cb-pagination',
  styles: [require('./cb-pagination.component.scss')],
  template: require('./cb-pagination.component.html')
})
export class CbPaginationComponent {
  @Input()
  public paginationObject = new CbPaginationModel();

  @Output()
  public pageChanged = new EventEmitter();

  public onPageChange(page: number): void {
    this.pageChanged.emit(page);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/+admin/modules/display/cb-pagination/cb-pagination.component.ts